<template>
  <th class="subsearch-toggle-area-bar" id="detailedsearch_tit_month">
    <p class="detailedsearch_tit">
      開催時期
    </p>

    <ul class="detailedsearch_list">
      <li v-for="item in monthsStore.master" :key="item.code">
        <label :for="`months_${item.code}`">
          <input type="checkbox"
                v-model="checkboxValue"
                :id="`months_${item.code}`"
                :value="item.code">
          <span>{{ item.text }}</span>
        </label>
      </li>
    </ul>
  </th>
</template>

<script setup>
import { computed, inject } from 'vue'

const monthsStore = inject('monthsStore')
const checkboxValue = computed({
  get: () => monthsStore.months.value,
  set: (value) => monthsStore.set(value)
})
</script>
